import { Box } from "@mantine/core";
import type { ReactNode } from "react";

type Props = {
  aiFilled: boolean;
  /** Retained as metadata for analytics and future accessible autofill messaging. */
  showGap?: boolean;
  children: ReactNode;
};

export function AiFilledField({ aiFilled, showGap = false, children }: Props) {
  const highlightGap = showGap && !aiFilled;
  return (
    <Box
      data-ai-filled={aiFilled ? "true" : undefined}
      data-needs-review={highlightGap ? "true" : undefined}
    >
      {children}
    </Box>
  );
}
